import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useToggle } from 'core/hooks/useToggle';

import './Question.scss';

function Question({
  id, title, children, isSectionExpanded,
}) {
  const { hash } = useLocation();
  const [open, toggle] = useToggle(false);

  useEffect(() => {
    const hashIdentifier = hash.replace('#', '');

    if (hashIdentifier === id) {
      toggle(true);
    }
  }, [hash, id, toggle]);

  // Need this to check for first render
  const notInitialRender = useRef(false);

  useEffect(() => {
    if (notInitialRender.current) {
      if (isSectionExpanded !== open) toggle(isSectionExpanded);
    } else {
      notInitialRender.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSectionExpanded, toggle]);

  const componentClassName = `mn_questionCollapsible ${open ? 'mn_opened' : ''}`;

  return (
    <div id={id} className={componentClassName} data-test="faq-question-answer">
      <div className="mn_question">
        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
        <div
          className="mn_caret"
          role="button"
          tabIndex={0}
          onClick={toggle}
          data-test="faq-question"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      </div>
      <div className="mn_answer">
        {children}
      </div>
    </div>
  );
}

export default Question;
